import { regionLabel } from "../lib/regions";

/**
 * Where a workload runs, as a list-row aside: the same filled dot the Region
 * picker uses for a region with a server in it, and the region's name.
 *
 * Shown only where it disambiguates. A list whose rows are all in one region
 * would carry the same word on every line and say nothing; the detail page
 * header names the region for anyone who wants it on a single workload.
 */
export function RegionTag({ region }: { region: string | null }) {
  const label = regionLabel(region);
  if (!label) return null;
  return (
    <span className="inline-flex shrink-0 items-center gap-1.5 text-[12px] text-fg-subtle">
      <span aria-hidden="true" className="size-1.5 rounded-full bg-mint" />
      {label}
    </span>
  );
}

/** Whether a list spans more than one region — the condition for showing the tag. */
export function spansRegions(rows: { region: string | null }[]): boolean {
  return new Set(rows.map((row) => row.region).filter(Boolean)).size > 1;
}
